import { useCallback, useEffect, useState } from 'react';
import { getDocumentsOption } from 'services/inspections';
import { AssetIssues } from 'types/room';
import { Documentation } from 'types/documents';
export type TypeDocumentOption = Documentation;
export const useGetDocumentOption = (rowActive?: AssetIssues) => {
  const [documentOptions, setDocumentOptions] = useState<TypeDocumentOption[]>([]);
  const [modelFiles, setModelFiles] = useState<TypeDocumentOption[]>([]);
  const handleGetDocumentsOption = useCallback(async () => {
    if (!rowActive?.submitId || !rowActive?.id) return;
    const data = await getDocumentsOption({
      submitId: rowActive.submitId,
      submittedAssets: rowActive.id
    });
    setModelFiles(data.modelFiles || []);
    setDocumentOptions(data.documentations || []);
  }, [rowActive?.id, rowActive?.submitId]);

  useEffect(() => {
    handleGetDocumentsOption();
  }, [handleGetDocumentsOption]);

  return {
    documentOptions,
    modelFiles,
    setDocumentOptions
  };
};
